import { matchPath, useLocation } from 'react-router-dom';
import { PagePath } from '@routing/appUrls';

const useIsOpenedInExternalView = () => {
    const location = useLocation();

    return matchPath({ path: PagePath.modalExternalView, end: false }, location.pathname);
};

export default useIsOpenedInExternalView;
